import React from "react";

import { graphql } from "gatsby";

import MediaQuery from "cms/components/MediaQuery";
import Scroller from "cms/components/Scroller";
import Text from "cms/components/Text";
import {
  Container,
  Content,
  HeadlineContainer,
} from "./MordorSocialProofBlock.styles";

export interface MordorSocialProofBlockProps
  extends Queries.SanityMordorSocialProofBlock {}

const MordorSocialProofBlock: React.FC<MordorSocialProofBlockProps> = ({
  headline,
  quotes,
}) => (
  <Container>
    <Content>
      <HeadlineContainer>
        <Text variant="H3" as="h3" weight="medium">
          {headline}
        </Text>
      </HeadlineContainer>
      <MediaQuery $lessThan="large" style={{ width: "100%" }}>
        <Scroller quotes={quotes} columnCount={2} />
      </MediaQuery>
      <MediaQuery $greaterThan="large" style={{ width: "100%" }}>
        <Scroller quotes={quotes} columnCount={3} />
      </MediaQuery>
    </Content>
  </Container>
);

export const query = graphql`
  fragment MordorSocialProofBlock on SanityMordorSocialProofBlock {
    _key
    _type
    headline
    quotes {
      variant
      verifiedTag
      image { ...OptimizedImage }
      imageAlt
      _rawQuote (resolveReferences: { maxDepth: 5 })
      name
      socialsHandle
      url
    }
  }
`;

export default MordorSocialProofBlock;
